import Model from './Model';

export default class PaymentMethod extends Model {
    static TYPE_CARD = 'card';
    static TYPE_PAYPAL = 'paypal';
    static AUTHORIZATION_UNCOLLECTED = 'none';

    isCard() {
        return this.get('type') === PaymentMethod.TYPE_CARD;
    }

    isPaypal() {
        return this.get('type') === PaymentMethod.TYPE_PAYPAL;
    }

    isExpired() {
        const expYear = this.getAttribute('exp_year')?.value;
        const expMonth = this.getAttribute('exp_month')?.value;
        if (!expYear || !expMonth) {
            return false;
        }
        const now = new Date();
        return new Date(expYear, expMonth) <= now;
    }

    isDefault() {
        return this.has('is_default') && this.get('is_default');
    }

    needAuthorizationRecollection() {
        return (
            this?.getAttribute('authorization')?.value === PaymentMethod.AUTHORIZATION_UNCOLLECTED &&
            this.isDefault() &&
            this.isCard()
        );
    }

    hasAttributes(attributeName) {
        return this.get('payment_method_attributes').some(({ name }) => name === attributeName);
    }

    getAttribute(attributeName) {
        return this.hasAttributes(attributeName)
            ? this.get('payment_method_attributes').find(({ name }) => name === attributeName)
            : null;
    }
}
